<div class="min-h-screen grid grid-cols-1 lg:grid-cols-2">

  <!-- Left Image -->
  <div class="hidden lg:flex flex-col items-start bg-cover bg-top text-black p-10"
      style="background-image: url('assets/img/signup.png');">
      <h1 class="text-3xl font-bold leading-tight text-center">
        Reset your password and <br>
          get back to your account.
      </h1>
  </div>

  <!-- Right Section -->
  <div class="flex flex-col justify-center items-center bg-[#faf7f5] p-10">

    <!-- Logo -->
    <a routerLink="/" class="auth-logo-link mb-8" aria-label="CircledPlus home"><img src="/cir-home/images/circledplus-logo.svg" alt="CircledPlus" class="auth-logo" width="156" height="40" /></a>

    <!-- <h2 class="text-2xl font-bold mb-6">Reset / Password Password</h2> -->

    <div class="w-full max-w-md">
      <!-- <form *ngIf="step===1" [formGroup]="emailForm" (ngSubmit)="sendOtp()">

        <h2 class="text-2xl font-bold mb-6 text-center">Forgot Password</h2>

        <label class="block text-sm font-semibold text-gray-700 mb-4">
          Registered Phone/Email Address
        </label>
        <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                </svg>
            </div>
            <input formControlName="phone" type="text"
            placeholder="Enter your email/phone"
            class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-gray-900 placeholder-gray-400"
            [class.border-red-500]="phone?.invalid && phone?.touched">
        </div>
        <p class="text-blue-600 leading-relaxed" style="font-size: 8px;">
          If you enter a mobile number without a country code, 
          <span class="font-semibold">code</span> will be applied automatically.
        </p>

        <p *ngIf="phone?.invalid && phone?.touched" class="error-text text-red-500">
          Enter valid phone/email address
        </p>

        <button [disabled]="emailForm.invalid || loading"
          class="flex w-full justify-center items-center rounded-full mt-8 text-lg bg-zinc-950 px-4 py-3 font-semibold text-white shadow-sm hover:bg-[#8C52FF] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105">
          {{ loading ? 'Sending OTP...' : 'Send OTP' }}
        </button>
      </form> -->
      <form *ngIf="step === 1" [formGroup]="emailForm" (ngSubmit)="sendOtp()">

        <h2 class="text-2xl font-bold mb-6 text-center">Forgot Password</h2>
      
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2">
            Registered Phone / Email Address
          </label>
      
          <div class="relative">
      
            <!-- Left: flag button (phone) or person icon (email) -->
            <div class="absolute inset-y-0 left-0 flex items-center"
              [class.pl-2]="isPhoneInput()"
              [class.pl-3]="!isPhoneInput()">
      
              <ng-container *ngIf="isPhoneInput(); else emailIcon">
      
                <!-- Clickable flag + dial -->
                <button type="button" (click)="toggleDropdown()"
                  class="flex items-center gap-1 px-1 py-1 rounded hover:bg-gray-100 transition-colors cursor-pointer">
                  <span class="text-lg leading-none">{{ selectedCountry.flag }}</span>
                  <span class="text-xs font-medium text-gray-600">{{ selectedCountry.dial }}</span>
                  <span class="text-gray-400 text-xs">{{ dropdownOpen ? '▲' : '▼' }}</span>
                </button>
      
                <!-- Dropdown -->
                <div *ngIf="dropdownOpen"
                  class="absolute top-full left-0 mt-1 z-50 w-72 bg-white border border-gray-200 rounded-lg shadow-lg flex flex-col max-h-64 overflow-hidden">
      
                  <div class="p-2 border-b border-gray-100">
                    <input type="text"
                      [value]="searchQuery"
                      (input)="searchQuery = $any($event.target).value"
                      placeholder="Search country..."
                      class="w-full border border-gray-200 rounded-md px-3 py-1.5 text-sm outline-none focus:border-blue-500" />
                  </div>
      
                  <ul class="overflow-y-auto flex-1">
                    <li *ngFor="let country of filteredCountries"
                      (click)="selectCountry(country)"
                      class="flex items-center gap-2.5 px-3 py-2 cursor-pointer hover:bg-gray-50 text-sm"
                      [class.bg-blue-50]="country.code === selectedCountry.code">
                      <span class="text-lg w-6 text-center">{{ country.flag }}</span>
                      <span class="flex-1 text-gray-800">{{ country.name }}</span>
                      <span class="text-gray-400 font-medium text-xs">{{ country.dial }}</span>
                    </li>
                  </ul>
                </div>
      
              </ng-container>
      
              <!-- Email icon -->
              <ng-template #emailIcon>
                <div class="pointer-events-none">
                  <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                </div>
              </ng-template>
            </div>
      
            <!-- Input -->
            <input formControlName="phone"
              type="text"
              placeholder="Enter your phone or email"
              (input)="onAuthInput($event)"
              [class.pl-28]="isPhoneInput()"
              [class.pl-10]="!isPhoneInput()"
              class="block w-full pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-gray-900 placeholder-gray-400"
              [class.border-red-500]="phone?.invalid && phone?.touched" />
          </div>
      
          <!-- Animated hint -->
          <div @fadeSlide *ngIf="isPhoneInput()"
            class="mt-2 flex items-start gap-2 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg">
            <svg class="h-4 w-4 text-blue-500 mt-0.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <p class="text-xs text-blue-600 leading-relaxed">
              Country code <span class="font-semibold">{{ selectedCountry.dial }}</span>
              {{ selectedCountry.flag }} auto-applied. Tap the flag to change.
            </p>
          </div>
      
          <!-- Validation error -->
          <p *ngIf="phone?.invalid && phone?.touched" class="mt-1 text-sm text-red-500">
            Enter a valid phone number or email address
          </p>
        </div>
      
        <!-- Submit -->
        <button type="submit"
          [disabled]="emailForm.invalid || loading"
          class="flex w-full justify-center items-center rounded-full mt-8 text-lg bg-zinc-950 px-4 py-3 font-semibold text-white shadow-sm hover:bg-[#8C52FF] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105">
          <svg *ngIf="loading" class="animate-spin h-5 w-5 mr-2 text-white" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
          </svg>
          {{ loading ? 'Sending OTP...' : 'Send OTP' }}
        </button>
      
      </form>


      <!-- STEP 2 : OTP -->
      <form *ngIf="step===2" [formGroup]="otpForm" (ngSubmit)="verifyOtp()">

        <h2 class="text-2xl font-bold mb-6 text-center">Enter Verification OTP</h2>

        <input formControlName="otp"
          placeholder="Enter 6 digit OTP"
          maxlength="6"
          class="block w-full pl-10 mb-4 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-gray-900 placeholder-gray-400 text-center tracking-widest text-xl">

        <p *ngIf="otp?.invalid && otp?.touched" class="error-text">
          OTP must be 6 digits
        </p>

        <button [disabled]="otpForm.invalid || loading"
          class="flex w-full justify-center items-center rounded-full text-lg bg-zinc-950 px-4 py-3 font-semibold text-white shadow-sm hover:bg-[#8C52FF] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105">
          {{ loading ? 'Verifying...' : 'Verify OTP' }}
        </button>

        <p class="text-center mt-4 text-sm text-gray-600">
          Didn't receive code?
          <span (click)="resendOtp()" class="text-[#8C52FF] cursor-pointer">Resend</span>
        </p>
      </form>


      <!-- STEP 3 : RESET PASSWORD -->
      <form *ngIf="step===3" class="space-y-6 w-full max-w-md" [formGroup]="passwordForm" (ngSubmit)="resetPassword()">

        <h2 class="text-2xl font-bold mb-6 text-center">Create New Password</h2>
        <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                </svg>
            </div>
            <input formControlName="password" type="password"
            placeholder="New Password"
            class="block w-full pl-10 mb-4 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-gray-900 placeholder-gray-400">
        </div>
        <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                </svg>
            </div>
            <input formControlName="confirmPassword" type="password"
            placeholder="Confirm Password"
            class="block w-full pl-10 mb-4 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-gray-900 placeholder-gray-400 mt-4">
        </div>
        <p *ngIf="passwordForm.errors?.['mismatch'] && passwordForm.touched"
           class="error-text">
          Passwords do not match
        </p>

        <button [disabled]="passwordForm.invalid || loading"
          class="flex w-full justify-center items-center rounded-full text-lg bg-zinc-950 px-4 py-3 font-semibold text-white shadow-sm hover:bg-[#8C52FF] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105">
          {{ loading ? 'Updating...' : 'Reset Password' }}
        </button>
      </form>

      <p class="mt-6 text-center text-gray-600">
        Remember password?
        <a routerLink="/login" class="text-[#8C52FF] cursor-pointer hover:underline">Back to Login</a>
      </p>

    </div>
  </div>
</div>
